<template>
  <button class="flex gap-8 items-center justify-between cursor-pointer DropdownButton">
    <slot name="icon">
      <iconify-icon :icon="icon" class="icon" />
    </slot>
    <span class="small medium">{{ label }}</span>
  </button>
</template>

<script>
  export default {
    name: 'WDropdownMenuButton',
    props: {
      label: String,
      icon: {
        type: String,
        default: 'fa-solid:angle-down',
      },
    },
  };
</script>

<style lang="scss" scoped>
  @import '@/assets/styles/variables';

  .DropdownButton {
    padding: 0.83rem 1rem;
    border-radius: var(--theme-button-border-radius);
    height: 2.5rem;
    background-color: $neutral-gray-10;

    .icon {
      height: 1rem;
    }
  }
</style>
